import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["quantity", "total", "checkout", "decrement", "decrementWrap", "increment"]

  static values = {
    min: Number,
    max: Number,
    unitCents: Number,
    symbol: String,
    locale: String
  }

  connect() {
    this.count = this.minValue
    this.hideMinimumTooltip = this.hideMinimumTooltip.bind(this)
    document.addEventListener("click", this.hideMinimumTooltip)
    this.render()
  }

  disconnect() {
    document.removeEventListener("click", this.hideMinimumTooltip)
    this.hideMinimumTooltip()
  }

  decrement(event) {
    event.preventDefault()
    if (this.count <= this.minValue) {
      event.stopPropagation()
      window.jQuery(this.decrementWrapTarget).tooltip("show")
      return
    }

    this.count -= 1
    this.render()
  }

  increment(event) {
    event.preventDefault()
    if (this.count >= this.maxValue) return

    this.count += 1
    this.render()
  }

  render() {
    const atMin = this.count <= this.minValue

    this.quantityTarget.value = this.count
    this.totalTarget.textContent = this.formattedTotal()
    this.checkoutTarget.setAttribute("data-quantity", this.count)
    this.decrementTarget.disabled = atMin
    this.decrementTarget.style.pointerEvents = atMin ? "none" : ""
    this.incrementTarget.disabled = this.count >= this.maxValue
    if (!atMin) this.hideMinimumTooltip()
  }

  hideMinimumTooltip() {
    if (!this.hasDecrementWrapTarget || !window.jQuery) return

    const tooltip = window.jQuery(this.decrementWrapTarget).data("bs.tooltip")
    if (tooltip) tooltip.hide()
  }

  formattedTotal() {
    const cents = this.unitCentsValue * this.count
    const whole = Math.floor(cents / 100)
    const fraction = String(cents % 100).padStart(2, "0")
    const separator = this.localeValue === "fr" ? "," : "."

    return `${whole}${separator}${fraction}${this.symbolValue}`
  }
}
